import { render, staticRenderFns } from "./SysAccountMnagement.vue?vue&type=template&id=5b4c74fe&scoped=true"
import script from "./SysAccountMnagement.vue?vue&type=script&lang=js"
export * from "./SysAccountMnagement.vue?vue&type=script&lang=js"
import style0 from "./SysAccountMnagement.vue?vue&type=style&index=0&id=5b4c74fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c74fe",
  null
  
)

export default component.exports